import React, { useEffect } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { MAIN_BLUE } from '../../color';
import { useDispatch, useSelector } from 'react-redux';
import { SET_DATE_RANGE } from '../../constants';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

export default function MinMaxDateRangePicker(props) {
  const {
    maxDate,
    minDate,
    officialHolidays,
    wfhEditable,
    leavesList,
    disableWeekends = false,
  } = props;
  const location = useLocation();
  const isWfhApplication = location.pathname.toLowerCase().includes('wfh');
  const userDataState = useSelector((state) => state.taskOperation);
  const dateRangeState = useSelector((state) => state.dateRangeState);
  const [dateRangeStateArray, setDateRangeStateArray] = React.useState([
    {
      ...dateRangeState,
      startDate: new Date(dateRangeState.startDate),
      endDate: new Date(dateRangeState.endDate),
    },
  ]);
  const dispatch = useDispatch();

  const disableHolidaySelection = (date) => {
    // debugger;
    // if (!isWfhApplication) {
    // console.log('inside leave applicationnnnnnnnnnnnnn');
    if (moment(date).day() === 0 || moment(date).day() === 6) return true;
    if (
      Array.isArray(officialHolidays) &&
      officialHolidays.includes(moment(date).format('DD MM YYYY'))
    )
      return true;
    // }
    if (
      Array.isArray(leavesList) &&
      leavesList.includes(moment(date).format('DD MM YYYY'))
    )
      return true;
  };

  const handleSetState = (updatedState) => {
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        startDate: updatedState.startDate.toISOString(),
        endDate: updatedState.endDate.toISOString(),
        key: updatedState.key,
        color: MAIN_BLUE,
      },
    });
  };

  const isDateRangeValid = (updatedState) => {
    if (
      (!minDate ||
        updatedState?.startDate >=
          new Date(new Date(minDate).setHours(0, 0, 0, 0))) &&
      (!maxDate ||
        updatedState.endDate <
          new Date(new Date(maxDate).setHours(24, 0, 0, 0)))
    ) {
      return true;
    } else return false;
  };

  useEffect(() => {
    let array = [];
    let newDateRangeState = {
      ...dateRangeState,
      startDate: new Date(dateRangeState.startDate),
      endDate: new Date(dateRangeState.endDate),
    };
    array.push(newDateRangeState);
    setDateRangeStateArray(array);
  }, [dateRangeState]);

  const dateRange = (item) => {
    if (userDataState.edit || wfhEditable || item.range1) {
      if (!isDateRangeValid(item.range1)) return;
      props.onDateRangeSelection(item.range1);
      handleSetState(item.range1);
    } else {
      if (!isDateRangeValid(item.selection)) return;
      props.onDateRangeSelection(item.selection);
      handleSetState(item.selection);
    }
  };

  return (
    <>
      <DateRange
        disableMargin
        disabledDay={
          officialHolidays || leavesList || disableWeekends
            ? (date) => disableHolidaySelection(date)
            : () => {}
        }
        editableDateInputs={officialHolidays ? false : true}
        onChange={(item) => dateRange(item)}
        moveRangeOnFirstSelection={false}
        ranges={dateRangeStateArray}
        star
        color={MAIN_BLUE}
        maxDate={maxDate}
        minDate={minDate}
      />
    </>
  );
}
